import type { HomepageContent } from '../../cms/homepage'
import HomepageActionLink from './HomepageActionLink'

type PublicHistorySectionProps = {
  content: HomepageContent['publicHistory']
}

export default function PublicHistorySection({
  content,
}: PublicHistorySectionProps) {
  return (
    <section className="home-section">
      <div className="home-public-history">
        <div className="home-public-history-copy">
          <p className="eyebrow">Public history</p>
          <h2>{content.title}</h2>
          <p>{content.body}</p>
        </div>
        <div className="button-row home-public-history-actions">
          <HomepageActionLink className="button primary" href={content.primaryCtaHref}>
            {content.primaryCtaLabel}
          </HomepageActionLink>
          {content.secondaryCtaLabel && content.secondaryCtaHref && (
            <HomepageActionLink className="button" href={content.secondaryCtaHref}>
              {content.secondaryCtaLabel}
            </HomepageActionLink>
          )}
        </div>
      </div>
    </section>
  )
}
